import React, { useState } from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import ElectronicPrescriptionCreateForm from './ElectronicPrescriptionCreateForm';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';
import { Size } from '../../../../../Enums/Size.enum';
import styles from './ElectronicPrescriptionCreateModal.module.scss';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';

interface Props {
	opened: boolean;
	onClose: (needReload: boolean) => void;
	workplaceId: string;
}

const ElectronicPrescriptionCreateModal: React.FC<Props> = props => {
	const { opened, onClose, workplaceId } = props;
	const [size, setSize] = useState<Size>(Size.MD);
	const [packageInsertUrl, setPackageInsertUrl] = useState<string | null>(null);

	const { isCase } = useTreatmentContext();

	const handleShowPackageInsert = (url: string) => {
		setSize(Size.FULLSCREEN);
		setPackageInsertUrl(url);
	};

	const handleClosePackageInsert = () => {
		setSize(Size.MD);
		setPackageInsertUrl(null);
	};

	return (
		<Modal
			opened={opened}
			onClose={() => onClose(false)}
			fullScreen={false}
			size={size}
			wrapChat={isCase}>
			<Modal.Header
				title='nczi.electronicPrescription.create.title'
				firstUpper
			/>
			<Modal.Content style={{ padding: 0 }}>
				<div
					className={styles.wrapper}
					style={{
						height: packageInsertUrl ? 'calc(100vh - 210px)' : 'auto',
					}}>
					<div
						className={styles.formWrapper}
						style={{
							width: packageInsertUrl ? '45%' : '100%',
						}}>
						<ElectronicPrescriptionCreateForm
							onClose={onClose}
							onShowPackageInsert={handleShowPackageInsert}
							workplaceId={workplaceId}
						/>
					</div>
					{packageInsertUrl && (
						<div className={styles.packageListWrapper}>
							<div className={styles.controls}>
								<LinkButton
									title='nczi.electronicPrescription.detail.closePackageList'
									theme={Theme.RED}
									onClick={handleClosePackageInsert}
								/>
							</div>
							<object
								data={packageInsertUrl}
								type='application/pdf'
								title='nczi.electronicPrescription.detail.packageList'
								className={styles.packageListIframe}
							/>
						</div>
					)}
				</div>
			</Modal.Content>
		</Modal>
	);
};

export default ElectronicPrescriptionCreateModal;
